export const CYPRESS_DATA_ATTRIBUTE_NAME = 'data-cy';

// TODO GD Introduce typescript in all parts of Cypress so we can use enums
export const CypressDataAttributes = Object.freeze({
  MACHINE_CONFIG_PAGE: 'machine-config-page',
  MACHINE_CONFIG_PAGE_RUNNING_APPLICATION_WARNING: 'machine-config-running-application-warning',
});
